export function compactPaginationItems(currentPage, totalPages) {
  const current = Math.max(Number(currentPage) || 1, 1)
  const total = Math.max(Number(totalPages) || 1, 1)

  if (total <= 5) {
    return Array.from({ length: total }, (_, index) => ({
      key: `page-${index + 1}`,
      page: index + 1,
      label: String(index + 1),
      ellipsis: false,
    }))
  }

  const pages = current <= 3
    ? [1, 2, 3, 4, total]
    : current >= total - 2
    ? [1, total - 3, total - 2, total - 1, total]
    : [1, current - 1, current, current + 1, total]

  return pages.reduce((items, page, index) => {
    const previousPage = pages[index - 1]
    if (previousPage && page - previousPage > 1) {
      items.push({
        key: `ellipsis-${previousPage}-${page}`,
        page: null,
        label: '...',
        ellipsis: true,
      })
    }
    items.push({
      key: `page-${page}`,
      page,
      label: String(page),
      ellipsis: false,
    })
    return items
  }, [])
}
